import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Notice } from '~/types';

export const Container = styled.div`
  ${({ theme }) => css`
    display: flex;
    position: fixed;
    z-index: 999;
    bottom: calc(${theme.layout.chat_navigation_height} + 30px);
    left: 50%;
    justify-content: center;
    width: 100%;
    padding: 0 16px;
    transform: translateX(-50%);
  `}
`;

export const ToastContainer = styled.div<{ type: Notice }>`
  ${({ theme, type }) => css`
    display: flex;
    align-items: flex-start;
    width: 100%;
    min-width: 250px;
    max-width: 360px;
    min-height: 52px;
    padding: 16px;
    border: 1px solid
      ${type === 'error'
        ? theme.themeColor.negative
        : type === 'system'
        ? theme.content.content_light_1
        : theme.themeColor.main_1};
    border-radius: 8px;
    background: ${theme.backgroundColor.bg_dark_2};
    gap: 8px;
    backdrop-filter: blur(25px);
  `}
`;

export const IconBox = styled.div<{ type: Notice }>`
  ${({ theme, type }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${type === 'error'
      ? theme.themeColor.negative
      : type === 'system'
      ? theme.content.content_light_1
      : theme.themeColor.main_1};
  `}
`;

export const Text = styled.div`
  ${({ theme }) => css`
    span {
      display: block;
      color: ${theme.backgroundColor.bg_light_1};
      ${theme.fontStyle.text.body14_medium}
      word-break: keep-all;
    }
  `}
`;
